import { render } from "./CancelButton.vue?vue&type=template&id=319dc365&ts=true"
import script from "./CancelButton.vue?vue&type=script&lang=ts"
export * from "./CancelButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__